import { AbstractControl, ValidationErrors } from '@angular/forms';

export function Name(control: AbstractControl): ValidationErrors | null {
  const { value } = control;
  if (!value) return null;
  // eslint-disable-next-line no-useless-escape
  const regexp = new RegExp(/^[^0-9!@#$%^,_()[\];:"'`&&*\{{\}}<>\\\/?|=+~]+$/i);
  return value.match(regexp) ? null : { nameFormat: true };
}
